import Nullstack from 'nullstack';
export default function IconBrandMixpanel({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-mixpanel",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "4.5",
    cy: "12",
    r: "2.5"
  }), "   ", Nullstack.element("circle", {
    cx: "20.5",
    cy: "12",
    r: "1.5"
  }), "   ", Nullstack.element("circle", {
    cx: "13",
    cy: "12",
    r: "2"
  }), " ");
}